import React from 'react';
import { ItemOptions } from './styles';
import { Checkbox, RadioButton } from '@gerdau/hefesto';

export enum NotificationOptionsEnum {
  CHECKBOX = 'checkbox',
  RADIO = 'radio'
}

export type NotificationOptionProps = {
  type: NotificationOptionsEnum;
  content: NotificationContentProps[];
};

export type NotificationContentProps = {
  name: string;
  id: string;
  label: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  checked: boolean;
  value: string | number;
};

export const NotificationOption = ({
  type,
  content
}: NotificationOptionProps) => {
  return (
    <ItemOptions>
      {type === NotificationOptionsEnum.CHECKBOX &&
        content.map((c) => (
          <Checkbox
            name={c.name}
            id={c.id}
            key={c.name}
            checked={c.checked ?? true}
            onChange={c.onChange}
            value={c.value}
            label={c.label}
          />
        ))}
      {type === NotificationOptionsEnum.RADIO &&
        content.map((c) => (
          <RadioButton
            name={c.name}
            id={c.id}
            key={c.name}
            checked={c.checked ?? true}
            onChange={c.onChange}
            value={c.value.toString()}
            label={c.label}
          />
        ))}
    </ItemOptions>
  );
};
